import { actions } from './actions'

const initialState = {
  menus: {
    data: [],
    loading: false,
    error: '',
  },
  menusParents: {
    data: [],
    loading: false,
    error: '',
  },
  menu: {
    data: null,
    loading: false,
    error: '',
  },
}

export default function menuSitioReducer(state = initialState, action) {
  switch (action.type) {
    case actions.MENUS_LOAD_REQUESTED:
      return { ...state, menus: { ...state.menus, loading: true } }
    case actions.MENUS_LOAD_SUCCEEDED:
      return {
        ...state,
        menus: { ...state.menus, data: action.payload, loading: false },
      }
    case actions.MENUS_LOAD_FILED:
      return {
        ...state,
        menus: { ...state.menus, loading: false, error: action.error },
      }
    case actions.MENU_UPDATE_REQUESTED:
      return {
        ...state,
        menu: { ...state.menu, loading: true, error: '' },
      }
    case actions.MENU_UPDATE_SUCCEEDED:
      return {
        ...state,
        menu: { ...state.menu, data: action.payload, loading: false, error: '' },
      }
    case actions.MENU_UPDATE_FILED:
      return {
        ...state,
        menu: { ...state.menu, loading: false, error: action.error },
      }
    case actions.MENU_INSERT_REQUESTED:
      return {
        ...state,
        menu: { ...state.menu, loading: true, error: '' },
      }
    case actions.MENU_INSERT_SUCCEEDED:
      return {
        ...state,
        menu: { ...state.menu, data: action.payload, loading: false, error: '' },
      }
    case actions.MENU_INSERT_FILED:
      return {
        ...state,
        menu: { ...state.menu, loading: false, error: action.error },
      }
    case actions.MENU_DELETE_REQUESTED:
      return {
        ...state,
        menus: { ...state.menus, loading: true, error: '' },
      }
    case actions.MENU_DELETE_SUCCEEDED:
      return {
        ...state,
        menus: {
          ...state.menus,
          data: state.menus.data.filter(menu => menu.id !== action.payload),
          loading: false,
          error: '',
        },
      }
    case actions.MENU_DELETE_FILED:
      return {
        ...state,
        menus: { ...state.menus, loading: false, error: action.error },
      }
    case actions.MENUS_LOAD_ALL_PARENTS_REQUESTED:
      return { ...state, menusParents: { ...state.menusParents, loading: true } }
    case actions.MENUS_LOAD_ALL_PARENTS_SUCCEEDED:
      return {
        ...state,
        menusParents: { ...state.menusParents, data: action.payload, loading: false },
      }
    case actions.MENUS_LOAD_ALL_PARENTS_FILED:
      return {
        ...state,
        menusParents: { ...state.menusParents, loading: false, error: action.error },
      }
    case actions.MENU_BYID_LOAD_REQUESTED:
      return { ...state, menu: { ...state.menu, loading: true } }
    case actions.MENU_BYID_LOAD_SUCCEEDED:
      return {
        ...state,
        menu: { ...state.menu, data: action.payload, loading: false },
      }
    case actions.MENU_BYID_LOAD_FILED:
      return {
        ...state,
        menu: { ...state.menu, loading: false, error: action.error },
      }
    case actions.MENU_BYID_LOAD_INSERT_REQUESTED:
      return { ...state, menu: { ...state.menu, data: null, loading: false } }
    default:
      return state
  }
}
